export default __webpack_public_path__ + "static/media/post6.c232cd4a.jpg";